import _axios from 'axios'

const tokenName = import.meta.env.VITE_APP_TOKEN_NAME

const config = { baseURL: import.meta.env.VITE_API_URL }

_axios.defaults.headers.common.Accept = 'application/json'
_axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

const axios = _axios.create(config)
axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    const result = localStorage.getItem(tokenName)
    if (result) {
      config.headers.Authorization = `Bearer ${result}`
    }
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  },
)

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response
  },
  function (error) {
    const unAuthCode = 401
    // Do something with response error
    if (error.response && error.response.status === unAuthCode) {
      if (localStorage.getItem(tokenName)) {
        alert('인증이 만료되어 로그인이 해제되었습니다.\n 다시 로그인해주시기 바랍니다')

        localStorage.removeItem(tokenName)
        delete axios.defaults.headers.common.Authorization

        window.location.replace('/')
      }
    } else if (!error.response) {
      alert('네트워크 접속 상태가 불안정합니다.\n 잠시 후 다시 시도해주시기 바랍니다')
    }
    return Promise.reject(error)
  },
)

export default axios
